import{b as m}from"./utils-BuG-uH50.js";const G=r=>{const e=new Set;return r.forEach(t=>{const o=(t.products?t.products[0]:t).custom,d=(o==null?void 0:o.product_sets_top)||[],c=(o==null?void 0:o.products_sets_bottom)||[];[...d,...c].forEach(i=>{i.id&&e.add(i.id)})}),[...e]},R=async r=>{var s,l;if(!r.length)return{};const e="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,[,a]=window.location.pathname.split("/"),d=((a||"").split("-")[1]||"gb").toUpperCase(),c=r.map(n=>`gid://shopify/Product/${n}`),i=`
    query GetSetProductPrices($ids: [ID!]!) @inContext(country: ${d}) {
      nodes(ids: $ids) {
        ... on Product {
          id
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;try{const h=await(await fetch(e,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:i,variables:{ids:c}})})).json(),u={};return(l=(s=h.data)==null?void 0:s.nodes)==null||l.forEach(p=>{if(p!=null&&p.id){const _=p.id.replace("gid://shopify/Product/","");u[_]=parseFloat(p.priceRange.minVariantPrice.amount)}}),u}catch(n){return console.error("Failed to fetch set product prices:",n),{}}},E=(r,e)=>{if(!e||!Object.keys(e).length)return null;const t=r.custom,a=(t==null?void 0:t.product_sets_top)||[],o=(t==null?void 0:t.products_sets_bottom)||[],d=[...a,...o];if(!d.length)return null;let c=1/0;return d.forEach(i=>{const s=e[i.id];s!==void 0&&s<c&&(c=s)}),c===1/0?null:c},M=r=>{if(!Array.isArray(r)||r.length===0)return"";const e=new Map;return r.forEach(t=>{const a=t==null?void 0:t.url,o=Number(t==null?void 0:t.width);!a||!Number.isFinite(o)||o<=0||e.has(o)||e.set(o,a)}),e.size===0?"":[...e.entries()].sort(([t],[a])=>t-a).map(([t,a])=>`${a} ${t}w`).join(", ")},D=(r,e)=>{var d;if(!Array.isArray(r)||r.length===0)return e||"";const t=r.filter(c=>(c==null?void 0:c.url)&&Number(c==null?void 0:c.width)>0);if(t.length===0)return((d=r[0])==null?void 0:d.url)||e||"";const a=600;return t.reduce((c,i)=>{const s=Math.abs(Number(c.width)-a);return Math.abs(Number(i.width)-a)<s?i:c}).url},J=(r,{isSlide:e=!1,index:t=99,setProductPrices:a={}}={})=>{var S,v,P,C,I,F,z,A,N,V;const{key:o,title:d,link:c,imageInfo:i,sellingPrice:s,listPrice:l,custom:n,ticket:h}=r,u=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",p=((v=(S=i==null?void 0:i.images)==null?void 0:S[0])==null?void 0:v.sources)||[],_=D(p,i==null?void 0:i.thumbnail),$=M(p),x="(min-width: 1024px) 25vw, 50vw",g=(s==null?void 0:s.min)||0,y=(l==null?void 0:l.min)>(s==null?void 0:s.min)?l.min:0,f=(C=(P=n==null?void 0:n.product_hover_image)==null?void 0:P[0])==null?void 0:C.label,b=(F=(I=n==null?void 0:n.colour_count)==null?void 0:I[0])==null?void 0:F.label,w=(A=(z=n==null?void 0:n.collaboration_name)==null?void 0:z[0])==null?void 0:A.label,T=t<=2?"eager":"lazy",j=t<=2?"high":"auto",k=((N=n==null?void 0:n.product_sets_top)==null?void 0:N.length)>0||((V=n==null?void 0:n.products_sets_bottom)==null?void 0:V.length)>0?E(r,a):null;return`
    <${e?"li":"div"}
      class="product-card ${e?"splide__slide":""}"
      data-voyado-product
      data-product-key="${o}"
      data-product-ticket="${h}"
    >
      ${q(n,g,y)}
      ${H(r)}
      <a
        href="${u}${c}"
        class="product-card__image-container ${f?"has-hover":""}"
        aria-label="${d}"
      >
        <img
          src="${_}"
          ${$?`srcset="${$}" sizes="${x}"`:""}
          alt="Image of ${d}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${T}"
          fetchpriority="${j}"
        />
        ${f?`
          <img
            src="${f}"
            alt="Secondary image of ${d}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <div class="product-card__title-wrapper">
          <p class="product-card__title f1-lc">${d}</p>
          ${w?`<p class="product-card__collaboration f2-uc">${w}</p>`:""}
        </div>
        ${k!==null?L(k):O(g,y)}
      </div>
       <p
        data-product-id="${o}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${b&&b>1?`
        <p class="product-card__colour-count f2-lc">
          ${b} Colours
        </p>
      `:""}
    </${e?"li":"div"}>
  `},L=r=>`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">
        From ${m(r)}
      </span>
    </div>`,O=(r,e)=>{let t="",a="product-card__price--current";return e&&(t=`
      <span class="product-card__price--original f1-lc">
        ${m(e)}
      </span>
    `,a="product-card__price--discounted"),`
    <div class="product-card__price">
      ${t}
      <span class="${a} f1-lc">
        ${m(r)}
      </span>
    </div>`},q=(r,e,t)=>{if(e&&t&&e<t)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-e/t)*100)}% OFF
      </p>
    `;const a=d=>{var i,s;const c=(s=(i=r==null?void 0:r[d])==null?void 0:i[0])==null?void 0:s.label;return c&&!c.includes("-")?c:""},o=a("stock")||a("petite")||a("collection")||a("new")||a("back_in_stock")||a("available_to_rent")||a("nc_exclusive");return o?`
      <p class="product-card__label product-label product-label--default">
        ${o}
      </p>
    `:""},H=r=>{var t;const e=((t=r.link)==null?void 0:t.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${r.key}"
      data-product-handle="${e}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{J as b,G as c,R as f};
